<template>
	<b-row class="mt-3">
		<b-col xl="12">
			<transition name="slide-fade">
				<div>
					<div class="text-center w-100">
						<b-icon
							icon="three-dots"
							class="text-center"
							animation="cylon"
							font-scale="4"
							v-if="loadingStatus"
						></b-icon>
					</div>
					<div class="mb-3" v-if="!loadingStatus">
						<b-row>
							<b-col cols="12" xl="8" lg="7" md="7" sm="6">
								<b-form-group
									label=""
									label-for="per-page-select"
									label-cols-sm="0"
									label-cols-md="0"
									label-cols-lg="0"
									label-align-sm="center"
									label-size="sm"
									class="mb-2 per-page-select"
								>
								<label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
								<b-form-select
									id="per-page-select"
									class="diameter-report-select"
									v-model="perPage"
									:options="pageOptions"
									size="sm"
									v-on:input="changePageOption(perPage)"
								></b-form-select>
								</b-form-group>
							</b-col>
							<b-col cols="12" xl="4" lg="5" md="5" sm="6" class="customer-table-select">
								<b-form-group
									label=""
									label-for="filter-input"
									label-align-sm="right"
									label-size="sm "
									class="mb-0 per-page-select"
								>
									<label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
									<b-input-group size="sm">
										<b-form-input id="filter-input2" v-model="filter" class="mb-4"></b-form-input>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<div class="">
							<b-table
								striped
								hover
								:items="HLRData"
								:fields="HLRColumn"
								:current-page="currentPage"
								:filter="filter"
								:per-page="perPage"
								:filter-included-fields="filterOn"
								:sort-by.sync="sortBy"
								:sort-desc.sync="sortDesc"
								:sort-direction="sortDirection"
								head-variant="light"
								table-class="text-nowrap"
								class="data-management-table primary-table"
								sticky-header="true"
								thead-class="white"
								show-empty
								responsive
								small
								@filtered="onFiltered"
							>
							</b-table>
						</div>

						<b-row v-if="HLRData.length > 0" class="mt-4">
							<b-col >
								<p class="ml-3 nowrap">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
							</b-col>
							<b-col >
								<b-pagination
									class="flex-fill-custom pr-4 ml-3 justify-content-end"
									v-model="currentPage"
									:total-rows="totalRows"
									:per-page="perPage"
									size="sm"
								></b-pagination>
							</b-col>
						</b-row>
					</div>
				</div>
			</transition>
		</b-col>
	</b-row>
</template>

<script>
import pagination from "../../common/format/pagination";

export default {
	name: "HSS-Info",
	data() {
		return {
			loadingStatus: true,
			HLRData: [],
			HLRColumn: [
				{key: "key", label: "Key", sortable: true, sortDirection: "desc"},
				{key: "value", label: "Value", sortable: true, sortDirection: "desc"},
			],
			totalRows: 0,
			currentPage: 1,
			fromPage: 10,
			perPage: 10,
			pageOptions: [5, 10, 25],
			sortBy: "",
			sortDesc: false,
			sortDirection: "asc",
			filter: null,
			filterOn: [],
		};
	},
	mounted() {
		this.$root.$on("hssInfo", res => {
			this.loadingStatus = false;
			let column = "keyvaluepair";
			if (res && !res[column]) column = "hss";
			if (res && res[column]) {
				let resData = this.checkDuplitedArray(res[column]);
				resData.sort((a, b) => {
					if (a.key.toLowerCase() > b.key.toLowerCase()) {
						return 1;
					} else if (a.key.toLowerCase() < b.key.toLowerCase()) {
						return -1;
					} else {
						return 0;
					}
				});
				if (resData) {
					this.HLRData = resData;
					this.totalRows = resData.length;
				}
				this.getTotalRows();
			}
		});
	},
	methods: {
		getTotalRows() {
			if (this.perPage > this.totalRows) {
				this.fromPage = this.totalRows;
			} else {
				this.fromPage = this.perPage;
			}
		},
		startPage() {
		   return pagination.startPageFunc(this.currentPage, this.perPage)
		}, 
		lastPage() {
			return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows)
		},
		changePageOption(page) {
			this.getTotalRows();
		},
		checkDuplitedArray(arr) {
			var result = arr.reduce((unique, o) => {
				if (!unique.some(obj => obj.key === o.key && obj.value === o.value)) {
					unique.push(o);
				}
				return unique;
			}, []);
			return result;
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
      	},
	},
};
</script>
